import {getNeighborHexKeys} from "./getNeighborHexKeys";

export const isNeighborOrSameHexKeys = (hexKey1, hexKey2) => {
  if (hexKey1 === hexKey2) return true;

  const hexKey1Neighbours = getNeighborHexKeys(hexKey1);

  return hexKey1Neighbours.includes(hexKey2);
};